const React = require('react');

const IconWarning = () => (
  <svg className="andes-message__icon" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd" key="message-svg">
      <circle key="message-circle" cx="8" cy="8" r="7.25" strokeWidth="1.5" className="andes-message__icon-outer" />
      <g>
        <path d="M7.03 3.879h1.94l-.243 5.333H7.273z" className="andes-message__icon-inner" />
        <circle cx="8" cy="11.152" r="1" transform="matrix(1 0 0 -1 0 22.303)" className="andes-message__icon-inner" />
      </g>
    </g>
  </svg>
);

module.exports = IconWarning;
